import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { hideSidebar } from 'redux/navigation'
import { Menu } from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      push,
      hideSidebar,
    },
    dispatch
  )
}

class NavigationLinkItem extends React.Component {
  render() {
    const { children, item, push, hideSidebar } = this.props
    return (
      <Menu.Item
        {...{
          href: item.path,
          active: item.active,
          onClick: (event) => {
            event.preventDefault()
            push(item.path)
            hideSidebar()
          },
        }}>
        {children ? children : item.content}
      </Menu.Item>
    )
  }
}

NavigationLinkItem = connect(mapStateToProps, mapDispatchToProps)(
  NavigationLinkItem
)
export default NavigationLinkItem



// WEBPACK FOOTER //
// ./src/components/shared/Navigation/renditions/NavigationLinkItem.jsx